<template>
    <div class="main">
        <div class="title">
            学习中心
        </div>
        <div class="help_content">
            <div class="help_item" v-for="(item , index) in helpList" :key="index"
                @click="goLink(item)" v-show="item.visible">
                <img class="cover alignM fl marginR8" style="width:24px;height:24px;" :src="item.img" alt="">
                <span class="font_position">{{item.name}}</span>
                <img class="icon_position" style="width:16px;height:16px;" src="icon/userIcon/help_right.png" alt="">
            </div>
        </div>

    </div>
</template>


<script>
// part
import generalCmpPart from '@/components/part/generalCmpPart';

import appHelper from "@util/appHelper";
import welfareApi from "@api/welfare";

const config = {
};


export default {
    name:'learnCenter',
    extends : generalCmpPart,

    data(){
        return{
            appHelper : appHelper,
            helpList:[
            // {
            //     img: 'icon/userIcon/study_list_icon.png',
            //     name:'学习清单',
            //     type : 'goToPage',
            //     href: 'learnListMore',
            //     visible : true
            // },
            // {
            //     img: 'icon/userIcon/signin_icon.png',
            //     name:'签到',
            //     type : 'goToPage',
            //     href: 'operationMainintegral'
            // },
            // {
            //     img     : 'icon/userIcon/invite_friends_icon.png',
            //     name    : '邀请好友',
            //     type    : 'goToPage',
            //     href    : 'invite',
            //     visible : true
            // },
            {
                img     : 'icon/userIcon/offline_course.png',
                name    : '线下课程',
                type    : 'goToPage',
                href    : 'underlineCourseMyCourse',
                visible : true
            },
            // {
            //     img     : 'icon/userIcon/study_list_icon.png',
            //     name    : '教资学习',
            //     type    : 'redirect',
            //     href    : 'https://wkxue.cn/mobile.html#/login',
            //     visible : true
            // },
            {
                img     : 'icon/userIcon/new_user.png',
                name    : '新人必学',
                type    : 'newUserWelfare',
                visible : false
            },
            ],

            newUserWelfare : null
        }
    },
    methods:{

        goLink(item) {
            if (item.type === 'goToPage')
            {
                appHelper.goToPage(item.href);
            }
            else if (item.type === 'redirect')
            {
                appHelper.redirect(item.href);
            }
            else if (item.type === 'newUserWelfare')
            {
                if (this.newUserWelfare.hasReceive)     // 已领取去学习
                {
                    appHelper.goToPage('newPeopleLearnRequired', {
                        id : this.newUserWelfare.id
                    });
                }
                else    // 未领取，则去领取
                {
                    appHelper.goToPage('newPeopleGiftReceive', {
                        id : this.newUserWelfare.id
                    });
                }
            }

        }
    },
    mounted() {
        welfareApi.getNewUserWelfare((result) => {

            this.newUserWelfare = result;

            // 有数据代表有福利，显示菜单
            if (this.newUserWelfare)
            {
                this.helpList[this.helpList.length - 1].visible = true;
            }

        });
    }
}
</script>


<style lang="scss" scoped>
.main{
    //width:90%;
    margin:0 auto;
    background:#fff;
    margin-top: 16px;
    border-radius: 8px;
    padding: 0 16px;
    box-sizing: border-box;
}

.title{
    padding-top: 12px;
    font-size: 18px;

    font-weight: 600;
    color: #000;

}

.help_content{
    width: 100%;
    padding-bottom: 2px;
    .help_item{
        margin: 16px 0;
        width:100%;
        height: 24px;
        line-height: 24px;
        position: relative;
        .font_position{
            font-size: 14px;

            font-weight: 400;
            color: #333333;

        }
        .icon_position{
            position: absolute;
            top: 4px;
            right: 0px;
        }
    }
}

</style>
